import color from "../resource/color";

export enum OrderSubStatus {
  ALREADY_PAID = "ALREADY_PAID",
  WAITING_PAID = "WAITING_PAID",
  WAIT_APPROVE_CREDIT_LIMIT = "WAIT_APPROVE_CREDIT_LIMIT",
}

export const orderSubStatusLabel = {
  ALREADY_PAID: "ชำระเงินแล้ว",
  WAITING_PAID: "ยังไม่ได้ชำระเงิน",
  WAIT_APPROVE_CREDIT_LIMIT: "รออนุมัติ",
  PARTIAL_PAYMENT: "ชำระเงินบางส่วน",
};

export const orderSubStatusColor = {
  ALREADY_PAID: color.success,
  WAITING_PAID: color.warning,
  WAIT_APPROVE_CREDIT_LIMIT: "",
  PARTIAL_PAYMENT: color.yellow,
};

export enum CreditType {
  ALL = "ALL",
  PRIMARY = "PRIMARY",
  TEMPORARY_ORDER = "TEMPORARY_ORDER",
  TEMPORARY_CREDIT = "TEMPORARY_CREDIT",
  CN = "CN",
}

export const creditTypeLabel = {
  ALL: "ประเภททั้งหมด",
  PRIMARY: "วงเงินหลัก",
  TEMPORARY_ORDER: "วงเงินเกิน",
  TEMPORARY_CREDIT: "วงเงินชั่วคราว",
  CN: "ส่วนลด",
};

export enum InvoiceStatus {
  ALL = "ALL",
  COMPLETE = "PRIMARY",
  NON_COMPLETE = "NON_COMPLETE",
  NON_PAYMENT = "NON_PAYMENT",
}

export const invoiceStatusLabel = {
  ALL: "สถานะทั้งหมด",
  COMPLETE: "ชำระเงินแล้ว",
  NON_COMPLETE: "ชำระเงินบางส่วน",
  NON_PAYMENT: "ยังไม่ได้ชำระ",
};

export const invoiceStatusColor = {
  COMPLETE: color.success,
  NON_COMPLETE: color.softWarning,
  NON_PAYMENT: color.warning,
};

export enum InvoiceOrderStatus {
  ALL = "ALL",
  USED = "USED",
  SOME_USED = "SOME_USED",
  NOT_USED = "NOT_USED",
  COMPLETE = "COMPLETE",
  NON_COMPLETE = "NON_COMPLETE",
  NON_PAYMENT = "NON_PAYMENT",
  CANCELED = "CANCELED",
}

export const invoiceOrderStatusLabel = {
  ALL: "สถานะทั้งหมด",
  USED: "ใช้แล้ว",
  SOME_USED: "ใช้แล้วบางส่วน",
  NOT_USED: "ยังไม่ได้ใช้",
  COMPLETE: "ชำระเงินแล้ว",
  NON_COMPLETE: "ชำระเงินบางส่วน",
  NON_PAYMENT: "ยังไม่ได้ชำระเงิน",
  CANCELED: "ยกเลิก",
};

export const invoiceOrderStatusColor = {
  ALL: color.black,
  USED: color.primary,
  SOME_USED: color.softPrimary,
  NOT_USED: color.placeholder,
  COMPLETE: color.success,
  NON_COMPLETE: color.softWarning,
  NON_PAYMENT: color.hardWarning,
  CANCELED: color.error,
};

// COMPLETE, NON_COMPLETE, NON_PAYMENT, USED, SOME_USED, NOT_USED, CANCELED
